import actionCreatorFactory from 'typescript-fsa'
import { Wallet } from '@ynap/api-utils'
import { authApiActionCreatorFactory } from '../../utils/redux-thunk-fetch'
import { addCardThunk } from './addCardThunk'

const createAction = actionCreatorFactory('wallet-state')
const createAuthApiAction = authApiActionCreatorFactory(createAction)

const addCardAction = addCardThunk(createAction)

export type FetchWalletPayload = {
    walletItem?: Array<{
        walletItemId?: number
        cardToken: string
        primary: boolean
        expired: boolean
        card_holder: Record<string, unknown>
        card: {
            last_four_digits: string
            code: string
            expire_year: string
            expire_month: string
        }
    }>
}

/**
 * Create a redux thunk action to fetch wallet state
 *
 * @example
 *     store.dispatch(fetchWallet())
 *
 * @param params `GetWalletParams` - an object of type `GetWalletParams`
 * @returns a thunk action creator that can be called and dispatched to redux
 */
export const fetchWallet = createAuthApiAction<FetchWalletPayload>('FETCH_WALLET')(Wallet.getWallet)

/**
 * Create a redux thunk action to add a card to the wallet
 *
 * @example
 *     store.dispatch(addCard())
 *
 * @returns a thunk action creator that can be called and dispatched to redux
 */
export const addCard = addCardAction('ADD_CARD')

/**
 * Create a redux thunk action to update a card's details
 *
 * @example
 *     store.dispatch(updateCard(cardParams))
 *
 * @returns a thunk action creator that can be called and dispatched to redux
 */
export const updateCard = createAuthApiAction<Record<string, unknown>>('UPDATE_CARD')(Wallet.updateCard)

/**
 * Create a redux thunk action to fetch wallet state
 *
 * @example
 *     store.dispatch(deleteCard(cardParams))
 *
 * @returns a thunk action creator that can be called and dispatched to redux
 */
export const deleteCard = createAuthApiAction<Record<string, unknown>>('DELETE_CARD')(Wallet.deleteCard)

/**
 * Resets the deleteError flag for a card
 *
 * @example
 *     store.dispatch(resetLoadError("card_token_123"))
 *
 * @param cardToken - the token of the card to reset
 * @returns a redux action that can be passed to `dispatch`
 */
export const resetLoadError = createAction<string>('RESET_DELETE_ERROR')
